export default __webpack_public_path__ + "static/p1-f0b695a0e5efbf734d9de176cdb73663.png";